[].forEach.call(document.querySelectorAll('.archive .link'), (l) => {
	l.addEventListener('click', (e) => {
		document.body.classList.toggle('archive-open');
	})
})